<template>
    <header class="menu">
        <div class="open_responsive">
            <div class="mdi mdi-menu"></div>
        </div>
        <div class="menu_responsive_overlay"></div>
        <nav class="nav">
            <div class="logo_nav">
                <img src="@/assets/img/logito_demo.png" alt="" class="hhead_logo">
                <p class="hhead_iso">razzil</p>
            </div>
            <ul>
                <li :class="`menu_item ${isActive('dashboard')? 'current': ''}`" v-if="$can('manage', 'dashboard')">
                    <router-link tag="a" :to="{name:'dashboard'}">
                        <i class="mdi mdi-home"></i>
                        <span>Portada</span>
                    </router-link>
                </li>
                <li class="menu_item" v-if="$can('manage', 'clients')">
                    <a href="javascript:void(0)" class="data_acordeon mdi mdi-chevron-down">
                        <i class="mdi mdi-account-multiple"></i>
                        <span>Clientes</span>
                    </a>
                    <ul class="submenu">
                        <li :class="`${isActive('clients')? 'current': ''}`">
                            <router-link tag="a" :to="{name:'clients'}"><i class="mdi mdi-circle-medium"></i>
                                <span>Lista</span></router-link>
                        </li>
                        <li :class="`${isActive('clients-load-stock')? 'current': ''}`">
                            <router-link tag="a" :to="{name:'clients-load-stock'}"><i class="mdi mdi-circle-medium"></i>
                                <span>Cargar descuentos</span></router-link>
                        </li>
                    </ul>
                </li>
                <li class="menu_item" v-if="$can('manage', 'products')">
                    <a href="javascript:void(0)" class="data_acordeon mdi mdi-chevron-down">
                        <i class="mdi mdi-package"></i>
                        <span>Productos</span>
                    </a>
                    <ul class="submenu">
                        <li :class="`${isActive('products')? 'current': ''}`">
                            <router-link tag="a" :to="{name:'products'}"><i class="mdi mdi-circle-medium"></i>
                                <span>Lista</span></router-link>
                        </li>
                        <li :class="`${isActive('products-load')? 'current': ''}`">
                            <router-link tag="a" :to="{name:'products-load'}"><i class="mdi mdi-circle-medium"></i>
                                <span>Cargar productos</span></router-link>
                        </li>
                        <li :class="`${isActive('products-load-stock')? 'current': ''}`">
                            <router-link tag="a" :to="{name:'products-load-stock'}"><i
                                class="mdi mdi-circle-medium"></i>
                                <span>Cargar stock</span></router-link>
                        </li>
                    </ul>
                </li>
                <li :class="`menu_item ${isActive('orders')? 'current': ''}`"  v-if="$can('manage', 'orders')">
                    <router-link tag="a" :to="{name:'orders'}">
                        <i class="mdi mdi-cart"></i>
                        <span>Pedidos</span>
                    </router-link>
                </li>
                <li :class="`menu_item ${isActive('users')? 'current': ''}`" v-if="$can('manage', 'users')">
                    <router-link tag="a" :to="{name:'users'}">
                        <i class="mdi mdi-account-key"></i>
                        <span>Usuarios</span>
                    </router-link>
                </li>
            </ul>
        </nav>
        <div class="collapse">
            <i class="mdi mdi-chevron-left"></i>
        </div>
    </header>
</template>

<script>
    import {Can} from '@casl/vue'

    export default {
        components: {Can},
        data() {
            return {
                categories: [],
                subcategories: []
            }
        },
        methods: {
            isActive(input) {
                const self = this;
                return self.$route.name && self.$route.name === input;
            }
        },
        mounted: function () {

        }
    }
</script>



// WEBPACK FOOTER //
// src/components/common/Menu.vue